import { media, spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-background-wrap";
const box = {
  padding: `${spacing.md}`,
  [`@media (${media.queries.tablet.min})`]: {
    padding: `${spacing.lg}`
  },
  [`@media (${media.queries.desktop.min})`]: {
    padding: `${spacing["3xl"]}`
  }
};
function composeWrap(options) {
  const { color: bgColor = "white" } = options || {};
  let composed = {
    ...box
  };
  let className;
  let deprecatedAliases = [];
  if (bgColor === "white") {
    className = `${classNamePrefix}`;
  } else if (bgColor === "light") {
    composed = {
      ...composed,
      backgroundColor: color.gray.lighter
    };
    className = `${classNamePrefix}-light`;
    deprecatedAliases.push("umd-forms-layout");
  } else {
    composed = {
      ...composed,
      backgroundColor: color.gray.darker
    };
    className = `${classNamePrefix}-dark`;
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const white = composeWrap({ color: "white" });
const light = composeWrap({ color: "light" });
const dark = composeWrap({ color: "dark" });
export {
  composeWrap,
  dark,
  light,
  white
};
//# sourceMappingURL=wrap.js.map
